import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const MagicLinkCallback = loadAsyncComponent(
  () => import(/* webpackChunkName: "MagicLinkCallback" */ './Container'),
  'page'
);
